import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { InjectionToken } from "tsyringe";

export const storefrontValuesAuthApiClientToken = Symbol(
    "storefrontValuesAuthApiClientToken"
) as InjectionToken<ApiClientInterface>;
